module.exports = __webpack_public_path__ + "img/ba9bf98.png";